import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { QNonConformanceSeverity } from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";
import { NonConformanceSeverity } from "../../odata/appu4dm/AppU4DMModel";
import { useQuery } from "@tanstack/react-query";
import { ncKeys } from "./nc-keys";

export function useNCSeverity() {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getSeverity(),
    queryFn: ({ meta }) => fetchNCSeverity(meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    severities: data?.value?.sort((a, b) => (b.Val ?? 0) - (a.Val ?? 0)),
    ...query,
  };
}

type NonConformanceSeverityResponse = Pick<
  NonConformanceSeverity,
  "Id" | "NId" | "Name" | "Description" | "Val"
>;

function fetchNCSeverity(token: string) {
  const builder = createQueryBuilderV4(
    "NonConformanceSeverity",
    new QNonConformanceSeverity()
  ).select("Id", "NId", "Name", "Description", "Val");

  return odataFetch<NonConformanceSeverityResponse>({ builder, token });
}
